export const FileExtension = {
  videoFormats: ["mp4", "WMV", "WEBM", "flv", "avi", "3GP", "OGG", "m4v"],
  audioFormats: ["AIF", "cda", "mpa", "ogg", "wav", "wma", "mp3"],
  pptFormats: ["ppt", "pptx", "pps", "ppsx"],
  wordFormats: ["docx", "doc", "docm", "dotx"],
  imageFormats: ["jpg", "png", "jpeg"],
  pdfFormats: ["pdf"],
  spreadSheetFormats: ["xls", "xlsx"],
};
